module.exports = __webpack_public_path__ + "img/jr-icon-follow.2b4d100a.png";